import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "leaflet";
import { Observable } from "rxjs";
declare let L: any;

@Injectable()
export class GeocoderService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getCurrentLocation(): Observable<any> {
    return new Observable((observer) => {
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const location: any = { latitude: null, longitude: null };
          location.latitude = position.coords.latitude;
          location.longitude = position.coords.longitude;
          observer.next(location);
          observer.complete();
        });
      } else {
        observer.error("Unsupported Browser");
      }
    });
  }
}
